module.exports = {

    request: function (req: any, token: string) {

        this.options.http._setHeaders.call(this, req, {
            'X-RM-SessionId': token,
            // 'X-RM-IP': 'Client IP',
            // 'X-RM-UserAgent': 'User Agent'
        })
    },

    response: function (res: any) {
        return res.data.hasOwnProperty('sessionDetail') ? res.data.sessionDetail.sessionId : res.data.token
    }
}